import * as React from 'react'

import { inject, observer } from 'mobx-react'
import { classList } from 'react-classlist-helper'

import { SitePermitStatus } from '~/client/graph/types.generated'
import { ChartDay } from '~/client/src/shared/models/ChartDay'
import ILogisticItem from '~/client/src/shared/models/ILogisticItem'
import ProjectDateStore, {
  isWithinRange,
} from '~/client/src/shared/stores/ui/ProjectDate.store'

import LogisticsGanttStore from '../../LogisticsGantt.store'
import LogisticsTimelineArrow from './LogisticsTimelineArrow'

interface IProps {
  logisticItem: ILogisticItem
  logisticsGanttStore: LogisticsGanttStore

  projectDateStore?: ProjectDateStore
}

const DONE_STATUSES: string[] = [SitePermitStatus.Done, SitePermitStatus.Ended]

@inject('projectDateStore')
@observer
export default class LogisticsTimelineDays extends React.Component<IProps> {
  public render() {
    const {
      logisticsGanttStore: { timelineColumnDays },
    } = this.props

    return timelineColumnDays.map((day, index) => (
      <div
        key={day.ms}
        className={classList({
          'gantt-row relative row y-center full-height': true,
          'br-light-cool-grey': timelineColumnDays.length !== index + 1,
          'bg-palette-brand-lightest': day.isWeekend,
          'bg-white': !day.isWeekend,
        })}
      >
        {day.isToday && (
          <div className="absolute-block absolute-block-x-center bl2-secondary-50-dashed top0 z-index-10 bottom-0 bg-transparent" />
        )}
        {this.renderDayBar(
          day,
          !index,
          index === timelineColumnDays.length - 1,
        )}
      </div>
    ))
  }

  private renderDayBar = (
    day: ChartDay,
    isFirstDayOnChart: boolean,
    isLastDayOnChart: boolean,
  ): JSX.Element => {
    const { logisticItem, projectDateStore } = this.props
    if (!logisticItem?.startDate || !logisticItem?.endDate) {
      return null
    }

    const { startDate, endDate } = logisticItem
    const { addDays, isSameDay, startOfDay, endOfDay } = projectDateStore

    const startMs = startDate ? startOfDay(startDate).getTime() : 0
    const finishMs = endDate ? endOfDay(endDate).getTime() : 0

    const isActive = isWithinRange(day.ms, startMs, finishMs)
    const isStartDate = isSameDay(startDate, day.ms)
    const isEndDate = isSameDay(endDate, day.ms)
    const isDayBeforeFinish = isSameDay(day.ms, addDays(endDate, -1))

    if (!isActive) {
      return null
    }

    const dayEnd = endOfDay(day.ms)
    const shouldShowLeftArrow =
      isFirstDayOnChart && (day.ms > startMs || day.ms > startMs)
    const dayEndMs = dayEnd.getTime()
    const shouldShowRightArrow =
      isLastDayOnChart && (dayEndMs < finishMs || dayEndMs < finishMs)

    return (
      <div className="col y-center full-width">
        <div
          className={classList({
            'row relative z-index-3 gantt-timeline-bar no-grow bt-primary-30 bb-primary-blue': true,
            'start-day': isStartDate,
            'end-day': isEndDate,
            done: DONE_STATUSES.includes(logisticItem.status),
          })}
        >
          {shouldShowLeftArrow && (
            <LogisticsTimelineArrow isLeftArrow status={logisticItem.status} />
          )}
          {shouldShowRightArrow && (
            <LogisticsTimelineArrow
              isLeftArrow={false}
              status={logisticItem.status}
            />
          )}
        </div>
        <div
          className={classList({
            'gantt-timeline-sub-bar no-grow': true,
            'start-day': isStartDate,
            'day-before-finish': isDayBeforeFinish,
            'end-day': isEndDate,
          })}
        />
      </div>
    )
  }
}
